import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import IndexSectionDashboardNavigations2 from './components/dashboard-navigations/IndexSectionDashboardNavigations2';
import DemoForm from './pages/demo-form';
import MyDemos from './pages/my-demos';
import SharedDemos from './pages/shared-demos';
import DemoDetailsView from './pages/demo-details-view';
import Analytics from './pages/analytics';
import Help from './pages/help';
import AdminTrigger from './components/AdminTrigger';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  useEffect(() => {
    console.log('App component mounted');
    const scripts = [
      '/js/main.js',
      '/js/674900.js',
      '/js/674910.js',
      '/js/674914.js',
    ];
    const created: HTMLScriptElement[] = [];
    scripts.forEach((src) => {
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
      created.push(s);
    });
    return () => {
      created.forEach((s) => s.parentNode?.removeChild(s));
    };
  }, []);

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
        <AuthProvider>
          <Routes>
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <IndexSectionDashboardNavigations2 />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/my-demos" element={
            <ProtectedRoute>
              <Layout>
                <MyDemos />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/shared-demos" element={
            <ProtectedRoute>
              <Layout>
                <SharedDemos />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/demos/new" element={
            <ProtectedRoute>
              <Layout>
                <DemoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/demos/:id" element={
            <ProtectedRoute>
              <Layout>
                <DemoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/demo/:id" element={
            <ProtectedRoute>
              <Layout>
                <DemoDetailsView />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/demo-form" element={
            <ProtectedRoute>
              <Layout>
                <DemoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/demo-form/:id" element={
            <ProtectedRoute>
              <Layout>
                <DemoForm />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <Layout>
                <Help />
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
        <AdminTrigger />
      </AuthProvider>
    </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;